import { render, staticRenderFns } from "./MSalebar.vue?vue&type=template&id=0249b652&"
import script from "./MSalebar.vue?vue&type=script&lang=js&"
export * from "./MSalebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports